import { JobStatus, PublicJobDto } from '@mi-front/core';
import {
  Alert,
  AlertTitle,
  Box,
  CircularProgress,
  LinearProgress,
  LinearProgressProps,
  Typography,
} from '@mui/material';

interface JobStatusAlertProps<T extends PublicJobDto<any, any>> {
  job: T;
  children?: React.ReactNode;
  title?: React.ReactNode;
}

export function JobStatusAlert<T extends PublicJobDto>({
  job,
  children,
  title,
}: JobStatusAlertProps<T>) {
  const status = job.status;
  const progress = status === JobStatus.IN_PROGRESS ? job.progress : 0;

  if (status === JobStatus.COMPLETED) {
    return null;
  }

  return (
    <Alert
      sx={{
        '& .MuiAlert-message': {
          width: '100%',
          // display: 'flex',
          // alignItems: 'center',
          // gap: 1,
        },
      }}
      severity={(() => {
        return status === JobStatus.FAILED ? 'error' : 'info';
      })()}
      icon={status === JobStatus.IN_PROGRESS && <CircularProgress size={20} />}
    >
      <AlertTitle>
        {title ?? status.replace(/_/g, ' ')}
        {/* {typeof progress === 'number' &&
          progress > 0 &&
          ` (${Math.round(progress)}%)`} */}
      </AlertTitle>
      <Box>{children}</Box>
      {status === JobStatus.IN_PROGRESS && (
        <Box sx={{ width: '100%' }}>
          <LinearProgressWithLabel value={progress as number} />
        </Box>
      )}
    </Alert>
  );
}

export function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary' }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
